module.exports = __webpack_public_path__ + "img/drop-gem-button.1817b898.png";